// extracted by mini-css-extract-plugin
module.exports = {"titles":"BannerTitles_titles__dVABl","title":"BannerTitles_title__JKfdH","subtitlesGroup":"BannerTitles_subtitlesGroup__rPA1_","subtitle":"BannerTitles_subtitle__igXrb"};